import { all, put, takeEvery } from 'redux-saga/effects'
import {
  convenienceTestQuestionnaireActions,
  convenienceTestQuestionnaireAnswersActions,
} from '../../slices/convenienceTest'
import {
  convenienceTestsConfirmActions,
  convenienceTestsDraftActions,
} from '../../slices/convenienceTests'
import { clearConvenienceTestAction } from '../../store/actions'

function* cleanConvenienceTest() {
  yield all([
    put(convenienceTestQuestionnaireAnswersActions.reset()),
    put(convenienceTestsConfirmActions.clearData()),
    put(convenienceTestsDraftActions.clearData()),
    put(convenienceTestQuestionnaireActions.clearData()),
  ])
}
export function* watchClearConvenienceTest() {
  yield takeEvery(clearConvenienceTestAction.type, cleanConvenienceTest)
}
